import {
  APPOINTMENTS_FETCH_REQUEST,
  APPOINTMENTS_FETCH_SUCCESS,
  APPOINTMENTS_FETCH_FAILURE,
  APPOINTMENTS_CREATE_REQUEST,
  APPOINTMENTS_CREATE_SUCCESS,
  APPOINTMENTS_CREATE_FAILURE,
  APPOINTMENTS_UPDATE_REQUEST,
  APPOINTMENTS_UPDATE_SUCCESS,
  APPOINTMENTS_UPDATE_FAILURE,
  APPOINTMENTS_DELETE_REQUEST,
  APPOINTMENTS_DELETE_SUCCESS,
  APPOINTMENTS_DELETE_FAILURE,
  APPOINTMENTS_SET_SELECTED,
  APPOINTMENTS_CLEAR_SELECTED,
  APPOINTMENTS_SET_LOADING,
  APPOINTMENTS_SET_ERROR,
  APPOINTMENTS_CLEAR_ERROR
} from './appointmentsTypes.js';

import { mockAppointments } from '../../../data/mockData.js';

const mockDelay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const fetchAppointmentsRequest = () => ({
  type: APPOINTMENTS_FETCH_REQUEST
});

export const fetchAppointmentsSuccess = (appointments) => ({
  type: APPOINTMENTS_FETCH_SUCCESS,
  payload: appointments
});

export const fetchAppointmentsFailure = (error) => ({
  type: APPOINTMENTS_FETCH_FAILURE,
  payload: error
});

export const createAppointmentRequest = () => ({
  type: APPOINTMENTS_CREATE_REQUEST
});

export const createAppointmentSuccess = (appointment) => ({
  type: APPOINTMENTS_CREATE_SUCCESS,
  payload: appointment
});

export const createAppointmentFailure = (error) => ({
  type: APPOINTMENTS_CREATE_FAILURE,
  payload: error
});

export const updateAppointmentRequest = () => ({
  type: APPOINTMENTS_UPDATE_REQUEST
});

export const updateAppointmentSuccess = (appointment) => ({
  type: APPOINTMENTS_UPDATE_SUCCESS,
  payload: appointment
});

export const updateAppointmentFailure = (error) => ({
  type: APPOINTMENTS_UPDATE_FAILURE,
  payload: error
});

export const deleteAppointmentRequest = () => ({
  type: APPOINTMENTS_DELETE_REQUEST
});

export const deleteAppointmentSuccess = (appointmentId) => ({
  type: APPOINTMENTS_DELETE_SUCCESS,
  payload: appointmentId
});

export const deleteAppointmentFailure = (error) => ({
  type: APPOINTMENTS_DELETE_FAILURE,
  payload: error
});

export const setSelectedAppointment = (appointment) => ({
  type: APPOINTMENTS_SET_SELECTED,
  payload: appointment
});

export const clearSelectedAppointment = () => ({
  type: APPOINTMENTS_CLEAR_SELECTED
});

export const setLoading = (loading) => ({
  type: APPOINTMENTS_SET_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: APPOINTMENTS_SET_ERROR,
  payload: error
});

export const clearError = () => ({
  type: APPOINTMENTS_CLEAR_ERROR
});

export const fetchAppointments = () => async (dispatch, getState) => {
  dispatch(fetchAppointmentsRequest());
  
  try {
    await mockDelay(800);
    
    const { auth } = getState();
    let appointments = mockAppointments;
    
    // Filter appointments based on user role
    if (auth.role === 'Client') {
      appointments = appointments.filter(apt => 
        apt.attendees.some(attendee => attendee.id === auth.user.id)
      );
    } else if (auth.role === 'Advisor') {
      appointments = appointments.filter(apt => 
        apt.agenda === 'advisor-meetings' || 
        apt.attendees.some(attendee => attendee.id === auth.user.id)
      );
    }
    
    dispatch(fetchAppointmentsSuccess(appointments));
  } catch (error) {
    dispatch(fetchAppointmentsFailure(error.message));
  }
};

export const createAppointment = (appointmentData) => async (dispatch) => {
  dispatch(createAppointmentRequest());
  
  try {
    await mockDelay(1000);
    
    const newAppointment = {
      ...appointmentData,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    dispatch(createAppointmentSuccess(newAppointment));
  } catch (error) {
    dispatch(createAppointmentFailure(error.message));
  }
};

export const updateAppointment = (appointmentId, updates) => async (dispatch) => {
  dispatch(updateAppointmentRequest());
  
  try {
    await mockDelay(800);
    
    const updatedAppointment = {
      ...updates,
      id: appointmentId,
      updatedAt: new Date().toISOString()
    };
    
    dispatch(updateAppointmentSuccess(updatedAppointment));
  } catch (error) {
    dispatch(updateAppointmentFailure(error.message));
  }
};

export const deleteAppointment = (appointmentId) => async (dispatch) => {
  dispatch(deleteAppointmentRequest());
  
  try {
    await mockDelay(500);
    dispatch(deleteAppointmentSuccess(appointmentId));
  } catch (error) {
    dispatch(deleteAppointmentFailure(error.message));
  }
};